// Values must match the API's JSON casing (JsonStringEnumConverter with CamelCase naming policy).
export enum SnapshotPurpose {
    AdHoc = 'adHoc',
    PeriodClose = 'periodClose',
}
